
import type { PropType } from 'vue'
import type { DispatcherWorkplaceRecordWaitListStatus } from '@/modules/DispatcherWorkplaceModule/types'

import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        waitListStatus: {
            type: Object as PropType<DispatcherWorkplaceRecordWaitListStatus>,
            required: true,
        },
        showingIcon: {
            type: Boolean,
            default: false,
        }
    }
})
